module.exports = __webpack_public_path__ + "img/chevron-left.1395663a.svg";